import {useGetProductInCart} from 'hooks/product/useGetProductInCart';
import {ProductBuyStickyCartButton} from 'modules/product-card/components/ProductBuyStickyCartButton';
import {ProductBuyStickyCartCounter} from 'modules/product-card/components/ProductBuyStickyCartCounter';
import {FC} from 'react';

export const ProductBuyStickyCart: FC = () => {
    const productInCart = useGetProductInCart();

    if (productInCart) {
        return <ProductBuyStickyCartCounter />;
    }

    return <ProductBuyStickyCartButton />;
};
